export default __webpack_public_path__ + "static/media/bank_gpb.1ff75ba0.svg";